import CoreService from '@/core/core.service.js';
const debounce = require('lodash.debounce');
import regExpObj from '@/utils/regExp.js';

export default {
  components: {
  },
  data() {
    return {
      captchaImage: {
        content: ''
      },
      form: {
        socialCreditCode: '',
        password: ''
      }
    };
  },
  created() {
    this.$store.commit('RESET_ALL_INFO');
    // this.updateCaptchaImage();
  },
  methods: {
    // 更新图片验证码
    updateCaptchaImage() {
      CoreService.getCaptchaImage().then(res => {
        this.captchaImage = res;
      });
    },
    // 验证参数
    checkParams() {
      if (!this.form.socialCreditCode) {
        this.$errorMessage('请输入统一社会信用代码');
        return false;
      }
      if (!regExpObj.socialCreditCode.test(this.form.socialCreditCode)) {
        this.$errorMessage('请输入18位的统一社会信用代码');
        return false;
      }
      if (!this.form.password) {
        this.$errorMessage('请输入密码');
        return false;
      }
      return true;
    },
    logonSystem: debounce(function () {
      if (this.checkParams()) {
        CoreService.logonSystem(this.form).then(() => {
          this.$store.dispatch('getUserInfo').then(() => {
            this.$router.replace('/app/index');
          });
        }).catch(error => {
          this.$errorMessage(error.data);
        });
      }
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    pageSkip (url) {
      this.$router.push(url);
    }
  }
};
